import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LockIcon from '@mui/icons-material/Lock';
import { Box, Button, Stack, Typography } from '@mui/material';
import type { JSX } from 'react';

/**
 * business-logic-model-web-oberflaeche, Abschnitt "Authentifizierung —
 * geschlossene Lücke": eigene Vollbild-Fehlerseiten für 401/403/503 statt der
 * bildschirmspezifischen Fehlertexte aus Anhang A.
 */
export function ForbiddenScreen({ message }: { readonly message: string | undefined }): JSX.Element {
  return (
    <FullScreenMessage
      icon={<LockIcon fontSize="large" color="error" data-testid="forbidden-icon" />}
      title="Kein Zugriff für dieses Konto."
      body={message ?? 'Kein Zugriff für dieses Konto.'}
    />
  );
}

export function IdentityProviderUnavailableScreen(): JSX.Element {
  return (
    <FullScreenMessage
      icon={<ErrorOutlineIcon fontSize="large" color="warning" data-testid="idp-unavailable-icon" />}
      title="Die Anmeldung ist gerade nicht möglich."
      body="Die Anmeldung ist gerade nicht möglich. Versuche es in ein paar Minuten erneut."
      action={
        <Button
          data-testid="idp-unavailable-retry-button"
          variant="outlined"
          onClick={() => window.location.reload()}
        >
          Erneut versuchen
        </Button>
      }
    />
  );
}

function FullScreenMessage({
  icon,
  title,
  body,
  action,
}: {
  readonly icon: JSX.Element;
  readonly title: string;
  readonly body: string;
  readonly action?: JSX.Element;
}): JSX.Element {
  return (
    <Box
      data-testid="auth-error-boundary"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
    >
      <Stack spacing={2} alignItems="center" maxWidth={420} textAlign="center" p={4}>
        {icon}
        <Typography variant="h2">{title}</Typography>
        <Typography variant="body1" color="text.secondary">
          {body}
        </Typography>
        {action}
      </Stack>
    </Box>
  );
}
